import { partners } from "@/data/partners";

/**
 * Partners are named as linked text, not logos.
 *
 * Reproducing a partner's mark requires written permission; until the client
 * confirms it for each organisation (`logoApproved`), naming them is accurate
 * and carries no implied endorsement.
 */
export function PartnerStrip({ tone = "light" }: { tone?: "light" | "dark" }) {
  const dark = tone === "dark";

  return (
    <div>
      <h2
        className={`text-[0.8125rem] font-bold uppercase tracking-[0.14em] ${
          dark ? "text-sky" : "text-blue"
        }`}
      >
        Delivered in partnership with
      </h2>
      <ul className="mt-5 grid gap-5 sm:grid-cols-2">
        {partners.map((partner) => (
          <li
            key={partner.name}
            className={`rounded-[14px] border p-5 ${
              dark ? "border-white/20 bg-white/5" : "border-line bg-white"
            }`}
          >
            <a
              href={partner.href}
              target="_blank"
              rel="noreferrer noopener"
              className={`text-[1.0625rem] font-semibold underline underline-offset-4 ${
                dark ? "text-white decoration-white/40 hover:decoration-white" : "text-navy decoration-line-strong hover:decoration-navy"
              }`}
            >
              {partner.name}
            </a>
            <p className={`mt-2 text-[0.9375rem] ${dark ? "text-white/75" : "text-muted"}`}>
              {partner.role}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
}
